// @ts-strict-ignore
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import React from 'react'
import { Slider } from '../../../atoms'
import { TopPicksCard, TopPicksCardDesktop } from './card'
import classNames from 'classnames'

const getReview = (id, reviews) => {
  return reviews.find((r) => r?.fields?.id?.id === id)
}

const TopPicks = (props) => {
  const {
    data,
    name,
    displayInfo,
    variant,
    sys,
    title,
    subTitle,
    reviews,
    brand,
    fullProductData,
    path,
  } = props
  const isSingleCard = data && data.length < 2
  try {
    return (
      <div
        className='top-picks'
        id={removeWhitespaceAndSpecialChars(name)}
        data-controller='platinum-carousel'
      >
        {title && <h2 className='top-picks__heading'>{title}</h2>}
        {subTitle && <p className='top-picks__description'>{subTitle}</p>}
        <div
          className={classNames('top-picks__container', {
            'top-picks__container--single': isSingleCard,
          })}
          data-platinum-carousel-target='carouselContainer'
        >
          {data.map((ele, i) => {
            const review = getReview(ele._id, reviews.reviews)
            return isSingleCard ? (
              <div>
                {TopPicksCardDesktop(
                  ele,
                  variant,
                  name,
                  sys,
                  displayInfo[0] || displayInfo,
                  review,
                  reviews.includes,
                  brand,
                  fullProductData.find((d) => d?._id === ele._id),
                  path,
                )}{' '}
                <div className='hide-on-desktop'>
                  {TopPicksCard(
                    ele,
                    variant,
                    name,
                    sys,
                    displayInfo[0] || displayInfo,
                    review,
                    reviews.includes,
                    brand,
                    fullProductData.find((d) => d?._id === ele._id),
                    path,
                  )}
                </div>
              </div>
            ) : (
              TopPicksCard(
                ele,
                variant,
                name,
                sys,
                displayInfo[i],
                review,
                reviews.includes,
                brand,
                fullProductData.find((d) => d?._id === ele._id),
                path,
              )
            )
          })}
        </div>
        <div className='top-picks__nav'>
          {!isSingleCard && data.length > 1 && <Slider cards={data} variant={'primary'} />}
        </div>
      </div>
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(`TOP PICKS MISSING: ${e}`))
  }
}

export default TopPicks
